<template>
  <empty-box class="query-form">
    <a-form-model :model="form" ref="form">
      <a-row :gutter="24">
        <a-col :span="8" v-if="config.includes('产品名称')">
          <a-form-model-item label="产品名称" prop="productID">
            <a-select
              v-model="form.productID"
              showSearch
              :showArrow="false"
              allowClear
              placeholder="请输入产品名称"
              :filterOption="filterOption"
              :defaultActiveFirstOption="false"
            >
              <a-select-option
                v-for="product in products"
                :key="product.id"
                :value="product.id"
              >{{product.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="8" v-if="config.includes('串号')">
          <a-form-model-item label="串号" prop="serialNumber">
            <a-input v-model="form.serialNumber" :maxLength="32" placeholder="请输入串号" allowClear />
          </a-form-model-item>
        </a-col>

        <a-col :span="8" v-if="$store.state.role === 'admin' && config.includes('生产者账号')">
          <a-form-model-item label="生产者账号" prop="producerUsername">
            <!-- <a-input
              v-model="form.producerUsername"
              :maxLength="32"
              placeholder="请输入生产者账号"
              allowClear
            />-->

            <a-select
              v-model="form.producerUsername"
              showSearch
              :showArrow="false"
              allowClear
              placeholder="请输入生产者账号"
              :defaultActiveFirstOption="false"
            >
              <a-select-option
                v-for="item in producers"
                :key="item.id"
                :value="item.userName"
              >{{item.userName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="8" v-if="config.includes('创建时间')">
          <a-form-model-item label="创建时间" prop="dateRange">
            <a-range-picker
              v-model="form.dateRange"
              style="width: 100%;"
              :ranges="{
                '昨天': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')], 
                '今天': [moment().startOf('day'), moment().endOf('day')], 
                '本周': [moment().startOf('week'), moment().endOf('week')], 
                '本月': [moment().startOf('month'), moment().endOf('month')],
                '本年': [moment().startOf('year'), moment().endOf('year')],
              }"
              allowClear
              format="YYYY-MM-DD HH:mm:ss"
              :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
              }"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="8" v-if="config.includes('操作类型')">
          <a-form-model-item label="操作类型" prop="recordType">
            <a-select
              v-model="form.recordType"
              :defaultActiveFirstOption="false"
              placeholder="请选择"
              allowClear
            >
              <a-select-option :value="0">激活</a-select-option>
              <a-select-option :value="1">预激活</a-select-option>
              <a-select-option :value="3">再次激活</a-select-option>
              <a-select-option :value="4">绑定硬件</a-select-option>
              <a-select-option :value="5">解绑硬件</a-select-option>
              <a-select-option :value="6">删除硬件</a-select-option>
              <a-select-option :value="7">用户备案</a-select-option>
              <a-select-option :value="8">更改保修期</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="8" v-if="config.includes('通信编号')">
          <a-form-model-item label="通信编号" prop="communicationSerialNo">
            <a-input v-model="form.communicationSerialNo" :maxLength="32" placeholder="请输入通信编号" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="btn-container">
      <a-button type="primary" @click="handleQuery">查询</a-button>
      <a-button @click="resetForm">重置</a-button>
    </div>
  </empty-box>
</template>

<script>
import moment from 'moment'
import { queryProduct, queryProducers } from '../api/api'

export default {
  name: 'query-form',

  props: ['config'],

  data() {
    return {
      form: {
        serialNumber: undefined, //串号
        dateRange: [], //创建时间
        recordType: undefined, //操作类型
        productID: undefined, //产品ID
        productName: undefined, //产品名称
        producerUsername: undefined, //生产者账号
        communicationSerialNo: undefined // 通信编号
      },
      products: [],
      producers: []
    }
  },

  created() {
    if (this.$store.state.role === 'admin') {
      this.queryProducers()
    }
    this.queryProduct()
  },

  methods: {
    moment,

    queryProduct() {
      queryProduct().then(res => {
        this.products = res.response.products
      })
    },

    queryProducers() {
      queryProducers().then(res => {
        this.producers = res.response.producers
      })
    },

    handleQuery() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //拼参数
          let params = {}
          params.serialNumber =
            this.form.serialNumber === '' ? undefined : this.form.serialNumber //串号
          params.recordType =
            this.form.recordType === '' ? undefined : this.form.recordType //操作类型
          params.productID =
            this.form.productID === '' ? undefined : this.form.productID //产品ID
          params.producerUsername =
            this.form.producerUsername === ''
              ? undefined
              : this.form.producerUsername //生产者账号
          params.communicationSerialNo =
            this.form.communicationSerialNo === ''
              ? undefined
              : this.form.communicationSerialNo //通信编号

          if (this.form.dateRange.length === 0) {
            params.stime = -28800000
            params.etime = 11587891746587
          } else {
            params.stime = this.form.dateRange[0].valueOf()
            params.etime = this.form.dateRange[1].valueOf()
          }

          params.size = 10
          params.current = 1

          params.isQuery = true

          this.$emit('fetch-data', params)
        }
      })
    },

    resetForm() {
      this.$refs.form.resetFields()
    },

    filterOption(input, option) {
      let item = this.products.find(item => item.id === option.key)
      return item.name.toLowerCase().includes(input.toLowerCase())
    }
  }
}
</script>

<style scoped lang="less">
.query-form {
  /deep/ .ant-form-item {
    display: flex;
    .ant-form-item-label {
      min-width: 70px;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    button {
      margin-left: 16px;
    }
  }
}
</style>
